import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/i18n/LocaleProvider";
import { Checkbox } from "@/components/ui/checkbox";

interface LeadConsentProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  className?: string;
}

/**
 * GDPR consent checkbox for lead/booking forms.
 *
 * Captures an active, affirmative opt-in (Art. 6(1)(a) GDPR) before we may
 * contact a person for business / advertising purposes. The label links to the
 * privacy policy and references the right to withdraw consent at any time.
 */
export const LeadConsent = ({
  checked,
  onCheckedChange,
  id = "lead-consent",
  className = "",
}: LeadConsentProps) => {
  const { t } = useTranslation();
  const { localize } = useLocale();

  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-3 cursor-pointer text-left ${className}`}
    >
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5 shrink-0"
        required
      />
      <span className="text-xs leading-relaxed text-muted-foreground">
        {t("leadConsent.prefix")}{" "}
        <Link
          to={localize("/privacy-policy")}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline underline-offset-2 hover:text-primary/80"
        >
          {t("leadConsent.linkText")}
        </Link>
        {t("leadConsent.suffix")}
      </span>
    </label>
  );
};

export default LeadConsent;
